import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import styled from 'styled-components';

import useUser from 'hooks/useUser';

import { Navbar } from 'components/navbar/navbar.component';
import { SidebarMenu } from 'components/sidebar-menu/sidebar-menu.component';
import { SIDEBAR_WIDTH } from 'components/sidebar-menu/sidebar-menu.styles';
import { Footer } from 'components/footer/footer.component';
import { MonitoringDowngradeNotice } from 'components/monitoring-downgrade-notice/monitoring-downgrade-notice.component';
// import { WhatsappButton } from 'components/whatsapp-button/whatsapp-button.component';

export const ClientLayout = () => {
  const { currentUser } = useUser();

  if (currentUser?.documentNumber === '') {
    return <Navigate to="atualizar-dados" />;
  }

  return (
    <NavigationContainer>
      <Navbar />
      {/* Menu lateral (Figma, out/2026) — o conteúdo e o rodapé recuam a
          largura dele; no celular o menu é o que abre de lado */}
      <SidebarMenu />
      <Shifted>
        <Content>
          {/* <WhatsappButton /> */}
          <Outlet />
          {/* Free com inversor conectado: aviso único da mudança (out/2026) */}
          <MonitoringDowngradeNotice />
        </Content>
        <Footer />
      </Shifted>
    </NavigationContainer>
  );
};

const Shifted = styled.div`
  margin-left: ${SIDEBAR_WIDTH}px;

  @media only screen and (max-width: 950px) {
    margin-left: 0;
  }

  @media print {
    margin-left: 0;
  }
`;

const Content = styled.div`
  /* margin: auto; */
  background-color: ${(props) => props.theme.color.bg.muted};
  /* background-color: red; */
`;

const NavigationContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: red;
  height: 100%;
  width: 100%;
`;
